import * as React from "react";
import type { SVGProps } from "react";
const SvgWallbox = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
        <path
            fill="currentColor"
            d="M12.897 9.569a.553.553 0 1 0 0-1.108h-5.55a.553.553 0 0 0-.553.555c0 .306.247.553.553.553z"
        />
        <path
            fill="currentColor"
            d="m20.963 7.974-3.628-3.628v-.88c0-.918-.746-1.664-1.664-1.664H4.573c-.917 0-1.664.746-1.664 1.664V14.01a.554.554 0 0 0 1.11 0V3.466c0-.305.248-.554.554-.554h11.098c.307 0 .556.249.556.554v14.982a.555.555 0 0 1-.556.555H4.573a.554.554 0 0 1-.554-.555v-1.664a.556.556 0 1 0-1.11 0v1.664c0 .919.747 1.665 1.664 1.665h4.04a6.63 6.63 0 0 0 5.394 2.775c3.485 0 6.347-2.692 6.63-6.104h1.139V9.935a2.76 2.76 0 0 0-.813-1.961m-6.956 13.803a5.52 5.52 0 0 1-3.95-1.664h5.614c.918 0 1.664-.746 1.664-1.665V9.801l.623.621c.31.311.488.74.488 1.177v5.185h1.081a5.556 5.556 0 0 1-5.52 4.993m6.659-6.103h-1.111v-4.075c0-.74-.288-1.437-.812-1.961l-1.408-1.407V5.917l2.842 2.841c.31.311.489.739.489 1.177z"
        />
    </svg>
);
export default SvgWallbox;
